/**
 * Benachrichtigungen an Agents (Spec 3.2 / 8.5).
 *
 * **Drei Ereignisse, zwei Kanaele.** Spec 8.5 nennt Web Push, Slack und
 * E-Mail; gebaut sind Slack und E-Mail. `push` bleibt als Kanal-Wert im
 * Schema stehen (Spec 3.2 nennt ihn), hat aber keinen Zusteller — der
 * VAPID-Teil steht in `TODO.md`.
 *
 * **Default ohne Zeile:** hat ein Mitglied keine `notification_prefs`, gilt
 * {@link DEFAULT_NOTIFICATION_PREF} — E-Mail fuer alle drei Ereignisse. Ein
 * Support-System, das standardmaessig schweigt, waere die schlechtere
 * Voreinstellung; wer weniger will, legt eine Zeile an.
 *
 * Doku: docs/services/notifications.md
 */
import { z } from 'zod';
import { uuidSchema } from './common.js';
/** Spec 3.2: `push | slack | email`. `push` ist noch ohne Zusteller. */
export const NOTIFICATION_CHANNELS = ['push', 'slack', 'email'];
export const notificationChannelSchema = z.enum(NOTIFICATION_CHANNELS);
/** Kanaele, die tatsaechlich zustellen (Phase 5). */
export const DELIVERABLE_NOTIFICATION_CHANNELS = ['email', 'slack'];
/**
 * Die Ereignisse aus Spec 8.5, auf das reduziert, was ein Agent wirklich
 * braucht:
 *   - `assigned_to_me`  — ein Ticket wurde mir (oder meinem Team) zugewiesen
 *   - `customer_reply`  — Kundenantwort auf einem Ticket, das mir gehoert
 *   - `escalation`      — eine Eskalationsregel hat gegriffen (Spec 8.4)
 */
export const NOTIFICATION_EVENTS = ['assigned_to_me', 'customer_reply', 'escalation'];
export const notificationEventSchema = z.enum(NOTIFICATION_EVENTS);
export const notificationPrefSchema = z.object({
    id: uuidSchema,
    tenant_id: uuidSchema,
    member_id: uuidSchema,
    channel: notificationChannelSchema,
    events: z.array(notificationEventSchema),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
});
/** Ohne eigene Zeile gilt das hier (siehe Modul-Kommentar). */
export const DEFAULT_NOTIFICATION_PREF = {
    channel: 'email',
    events: NOTIFICATION_EVENTS,
};
/**
 * Die Einstellungen eines Mitglieds werden **komplett** ersetzt (gleiche Regel
 * wie `member_scopes` und Ticket-Tags): eine leere Liste heisst „gar keine
 * Benachrichtigungen", nicht „Default".
 */
export const updateNotificationPrefsSchema = z.object({
    prefs: z
        .array(z.object({
        channel: notificationChannelSchema,
        events: z.array(notificationEventSchema).max(NOTIFICATION_EVENTS.length),
    }))
        .max(NOTIFICATION_CHANNELS.length),
});
//# sourceMappingURL=notification.js.map